// Dependencies
require("section/organisations");



/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/block/organisations/index.js
 ** module id = 135
 ** module chunks = 0 1
 **/